var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-footer',{staticStyle:{"text-align":"center","padding":"0px 50px 25px 50px","margin-top":"30px"}},[_vm._v(" Macro Remote Control ©2023 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }